import ApiService from "../../services/api.service";

const ContractService = {

	getContractType(search) {
		return ApiService.get(`/contract-type/get-contract-type?value=${search}`)
	},
	createContractType(data) {
		return ApiService.post(`/contract-type/create`, data)
	},
	updateContractType(data) {
		return ApiService.put(`/contract-type/${data.id}`, data)
	},
	deleteContractType(id) {
		return ApiService.delete(`/contract-type/${id}`)
	},

	getContractStage(search) {
		return ApiService.get(`/stage-type/get-stage-type?value=${search}`)
	},
	createContractStage(data) {
		return ApiService.post(`/stage-type/create`, data)
	},
	updateContractStage(data) {
		return ApiService.put(`/stage-type/${data.id}`, data)
	},
	deleteContractStage(id) {
		return ApiService.delete(`/stage-type/${id}`)
	},

	getList(payload) {
		return ApiService.post(`/contract-management/list`, payload)
	},
	searchContracts(payload) {
		return ApiService.post(`/contract-management/list-for-prixod`, payload)
	},
	getNotificationList () {
		return ApiService.post(`/contract-management/notification`)
	},
	getContractById(id) {
		return ApiService.get(`/contract-management/${id}`)
	},
	getContractItems(contractId, docId) {
		return ApiService.get(`/contract-management/prixod-from-contract/${contractId}/${docId}`)
	},
	createContract() {
		return ApiService.get(`/contract-management/create`)
	},
	updateContract(data) {
		return ApiService.put(`/contract-management/update/${data.id}`, data)
	},
	deleteContract(id) {
		return ApiService.delete(`/contract-management/delete/${id}`)
	},
	createFile(contractId, file) {
		return ApiService.post(`/contract-management/upload-file/${contractId}`, file)
	},
	removeFile(fileId, contractId) {
		return ApiService.get(`/contract-management/delete-file/${fileId}/${contractId}`)
	},
	createPayment(data) {
		return ApiService.post(`/contract-fee-paid/create`, data)
	},
	getIncomeDocsByContractId(id) {
		return ApiService.get(`/contract-management/get-contract-documents/${id}`)
	}

}

export default ContractService
